import { render, staticRenderFns } from "./WidgetImageGalleryWithText.vue?vue&type=template&id=463faf53&scoped=true&"
import script from "./WidgetImageGalleryWithText.vue?vue&type=script&lang=js&"
export * from "./WidgetImageGalleryWithText.vue?vue&type=script&lang=js&"
import style0 from "./WidgetImageGalleryWithText.vue?vue&type=style&index=0&id=463faf53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463faf53",
  null
  
)

export default component.exports